import { render, staticRenderFns } from "./RegistryLayout.vue?vue&type=template&id=490fc162&"
import script from "./RegistryLayout.vue?vue&type=script&lang=js&"
export * from "./RegistryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports